import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
    // {
    //   path: '/',
    //   name: 'cardPay',
    //   component: () => import('@/views/cardPay_polling.vue')
    // },
    {
        path: '/checkout/:platformReference',
        name: 'checkoutPlatformReference',
        props: true,
        component: () => import('@/views/index.vue'),
    },
];

const router = new VueRouter({
    mode: 'history',
    routes,
});

export default router;
